<div class="flex-col gap-24 narrower-input form-wrapper">
  @let idValue = location._id;
  @if (idValue) {
  <div class="flex-col gap-8">
    <mat-label>{{ 'CORE_INFO_TAB.LOCATION_ID' | translate }}</mat-label>
    <div class="flex-row gap-5 start-center">
      <input class="ui-input w-100" disabled [value]="idValue" />
      <ui-copy-clipboard [copyContent]="idValue" style="margin-left: 8px" toolTip="Copy"></ui-copy-clipboard>
    </div>
  </div>
  }

  <div class="location-form">
    <app-add-location-from #form [location]="location"></app-add-location-from>
  </div>

  <div class="flex-row start-center">
    <ui-progress-button
      colorBgr="#ffffff"
      colorBorder="#DC2626"
      colorText="#DC2626"
      [text1]="'ACTIVITY_LOG.DELETE_LOCATION' | translate"
      [loading]="deleteProcess"
      [preloaderColor]="PreloaderColor.red"
      (clickAction)="deleteLocation()"
    ></ui-progress-button>
  </div>
</div>
